import React from 'react';

export const SortableContext = React.createContext<any>(null);

export function useSortableDiskContext() {
  return React.useContext(SortableContext);
}
